import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Checkbox,
  Grid,
  Typography,
  Autocomplete,
  Pagination,
  Skeleton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import TablePagination from "@mui/material/TablePagination";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import { FormatAmount } from "../FormatAmount";
import moment from "moment";
import * as XLSX from "xlsx";
import axios from "axios";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { ArrowBack, Error } from "@mui/icons-material";
import { IconButton } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { handleInvoiceClick } from "../CommonLink";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import { getRefrenceDataList } from "../../Invoices/actions";
const useStyles = makeStyles(dashboardStyle);

const FormatDate = (dateString) => {
  if (!dateString) return null;
  const parsedDate = moment(dateString);
  const formattedDate = parsedDate.format("DD MMM YYYY");
  return formattedDate;
};

const defaultFormValues = {
  RowsOfPage: 25,
  PageNo: 1,
  venderName: "All",
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  statusFilter: "All",
  sortColumn: undefined,
  invoiceNoFilter: undefined,
  invoice_Type: "",
  isAsc: false,
};
const defaultFormValuesDownload = {
  venderName: undefined,
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  statusFilter: undefined,
  sortColumn: undefined,
  invoiceNo: undefined,
  invoice_Type: "",
  isAsc: false,
  isPdf: false,
};
const NoCompilanceBased = ({
  header,
 complianceDate , 
  dropdownValue,
  loading,
  setData,
  setLoading,
  data,
  page,
}) => {
  console.log("dataList", data);
  const classes = useStyles();
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const [formState, setFormState] = useState(
    defaultFormValues || defaultFormValuesDownload
  );

  const [vendors, setVendors] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);
   const [multipleData, setMultipleData] = useState({
    invoice_Type: [],
  });

  const fetchData = async (params) => {
    setLoading(true);

    try {
      console.log("params", {
        pageNumber: formState?.PageNo,
        pageSize: 25,
        vendorName:
                 (params?.Vendor?.Vendor_Name === "All" ||    params?.Vendor?.Vendor_Name === "" )  ? undefined :   params?.Vendor?.Vendor_Name,
        invoiceNo: params.invoiceNoFilter?.trim() || "",
        invoiceType : params.invoice_Type,
        sortColumn: params.sortColumn,
        sortDirection: params.sortDirection,
      });
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Report/GetNonPoCompliance`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
          params: {
            pageNumber: params?.PageNo || 1,
            pageSize: params?.RowsOfPage || 25,
            vendorName:
            params?.Vendor?.Vendor_Name === "All" ? undefined :  params?.Vendor?.Vendor_Name,
            sortColumn: params.sortColumn,
            invoiceNo: params.invoiceNoFilter?.trim() || undefined,
            invoiceType : params?.invoice_Type === "" ? undefined :  params?.invoice_Type,
            isAsc: params.isAsc,
            startDate : complianceDate?.startDate === "" ? undefined : complianceDate?.startDate, 
            endDate : complianceDate?.endDate === "" ? undefined : complianceDate?.endDate
          },
        }
      );
      console.log("res:", res);
      setData(res?.data?.response);
      setCount(res?.data?.totalCount);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(()=> {
      console.log("called??")
  fetchData(formState)
    },[complianceDate])

  const resetFilter = async () => {
    setFormState(defaultFormValues);
    await fetchData(defaultFormValues);
  };
  const [listStatus, setListStatus] = useState([]);
  const [categories, setCategories] = useState([]);
  const [returnList, setReturnList] = useState([]);

  useEffect(() => {
    const fetchData = async (url, setter) => {
      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        });
        setter(response?.data); // Set the fetched data to the state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(
      `${process.env.REACT_APP_API_URL}/api/Report/GetStatusList`,
      setListStatus
    );
    fetchData(
      `${process.env.REACT_APP_API_URL}/api/Report/GetPendingWithList`,
      setCategories
    );
    fetchData(
      `${process.env.REACT_APP_API_URL}/api/Report/GetReturnByList`,
      setReturnList
    );
  }, []);
  console.log("latest", data);
  const [userList, setUserList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage + 1,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
  };
  useEffect(() => {
    fetchData(formState);
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState.sortColumn,
    formState.isAsc,
  ]);
    useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => { },
      setMultipleData
    );

  }, [])
  const handleSort = (index) => {
    if (index === formState.sortColumn) {
      setFormState((prevState) => ({
        ...prevState,
        isAsc: !prevState.isAsc,
      }));
    } else {
      setFormState((prevState) => ({
        ...prevState,
        sortColumn: index,
        isAsc: true,
      }));
    }
  };
  const fetchUserList = async (query) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getVendorDetails/${query ? query : null
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      setUserList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    if (searchQuery.trim() !== "") {
      fetchUserList(searchQuery);
    } else {
      fetchUserList();
    }
  }, [searchQuery]);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);

  const handleDownloadFile = async (params, fileType) => {
    if (fileType === "pdf") {
      setIsPdfLoading(true);
    } else if (fileType === "excel") {
      setIsExcelLoading(true);
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Report/DownloadNonPoCompliance`,
        {
          responseType: "blob",
          params: {
            vendorName:
            params?.Vendor?.Vendor_Name === "All" ? undefined :    params?.Vendor?.Vendor_Name,
            sortColumn: params?.sortColumn,
            isAsc: params?.isAsc,
            invoiceNo: params.invoiceNoFilter?.trim(),
            invoiceType : params?.invoice_Type === "" ? undefined :  params?.invoice_Type,
            isPdf: fileType === "pdf", // Set isPdf based on fileType
            startDate : complianceDate?.startDate === "" ? undefined : complianceDate?.startDate, 
            endDate : complianceDate?.endDate === "" ? undefined : complianceDate?.endDate
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      const blob = new Blob([response.data], {
        type:
          fileType === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        fileType === "pdf" ? `NonPOCompilanceBased.pdf` : "NoPOCompilanceBased.xlsx"
      );
      document.body.appendChild(link);
      link.click();
      if (fileType === "pdf") {
        setIsPdfLoading(false);
      } else if (fileType === "excel") {
        setIsExcelLoading(false);
      }
    } catch (error) {
      console.error(`Error downloading ${fileType} file:`, error);
      if (fileType === "pdf") {
        setIsPdfLoading(false);
      } else if (fileType === "excel") {
        setIsExcelLoading(false);
      }
    }
  };

  const handleDownloadExcel = () => {
    handleDownloadFile(formState, "excel");
  };

  const handleDownloadPDF = () => {
    handleDownloadFile(formState, "pdf");
  };
  
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
    const updatedFormState = {
      ...formState,
      [name]: value,
    };

  };

   useEffect(() => {
      if (vendors.length > 0 && vendors[0].Vendor_Code !== "-1") {
        const vendorsStrigify = JSON.stringify(vendors);
        const vendorsParse = JSON.parse(vendorsStrigify);
        vendorsParse.unshift({ Vendor_Code: "-1", Vendor_Name: "All" });
        setVendors(vendorsParse);
      }
    }, [vendors]);


      useEffect(() => {
        getVendorDetail(null, setVendors, setVendorLoading);
      
      }, []);

    const getVendorDetail = async (user, setUserData, setLoading) => {
      setLoading(true);
      //
      await axios({
        method: "get", //you can set what request you want to be
        url: `${
          process.env.REACT_APP_API_URL
        }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      })
        .then(async (res) => {
          setUserData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
    
          // setErrorMessage("Invalid username or password");
        });
    };

  return (
    <div>
      <Grid
        container
        justifyContent="space-between"
        style={{
          padding: "1px 27px",
          backgroundColor: "#031C30",
          color: "white",
          height: "62px",
        }}
      >
        <Grid item xs={6} sm={6} md={6} lg={6}>
          <h4> Non Po Based </h4>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6}>
          <IconButton
            variant="contained"
            style={{ float: "right", marginTop: "1.5%" }}
            onClick={() => navigate("/home")}
          >
            <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Typography>
            Vendor:
          </Typography>
      
<Autocomplete
                    // sx={{
                    //   "& .MuiInputBase-root": {
                    //     height: "30px",
                    //     textAlign: "center",
                    //     display: "flex",
                    //     alignItems: "center",
                    //   },
                    //   "& .MuiInputBase-input": {
                    //     marginTop: "-4px", // Adjust this value to move the text up
                    //     fontSize: 15,
                    //   },
                    // }}
                    id="Vendor"
                    options={vendors}
                    classes={{ option: classes.option }}
                    size="small"
                    name="Vendor"
                    value={formState.Vendor}
                    getOptionLabel={(option) =>
                      (option !== "" &&
                        `${
                          option?.Vendor_Code !== "-1"
                            ? `${option?.Vendor_Code}-`
                            : ""
                        }${option?.Vendor_Name}`) ||
                      ""
                    }
                    loading={vendorLoading}
                    onChange={(event, newValue) => {
                      autocompleteChangeHandler("Vendor", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        onChange={(event) => {
                          getVendorDetail(
                            event.target.value,
                            setVendors,
                            setVendorLoading
                          );
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Typography>
            Invoice No :
          </Typography>
          <TextField
            variant="outlined"
            value={formState.invoiceNoFilter || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                invoiceNoFilter: e?.target?.value,
              }));
            }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item
          xs={12}
          sm={12}
          md={4}
          lg={3}>
          <Typography style={{ color: "black" }}>
            Invoice Type:
          </Typography>
          <Autocomplete

            id="submitter_role"
            options={
              multipleData?.invoice_Type
            }
            size="small"
            value={{
              ReferenceCode: formState?.invoice_Type || "",
            }}
            //  disabled={disable}
            title="select select"
            getOptionLabel={(option) =>
              (option !== "" &&
                `${option?.ReferenceCode}`) ||
              ""
            }
            // loading={rolesLoading}
            onChange={(event, newValue) => {

              autocompleteChangeHandler("invoice_Type", newValue?.ReferenceCode);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                type="text"
                name=""
                placeholder="Select a value"
                required={formState?.isProceed}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={0} mb={5}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => fetchData(formState)}
              >
                Filter
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={resetFilter}
              >
                Reset Filter
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={handleDownloadExcel}
                disabled={isExcelLoading}
              >
                {isExcelLoading ? "Downloading.." : "Download Excel"}
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => handleDownloadPDF()}
                disabled={isPdfLoading}
              >
                {isPdfLoading ? "Downloading.." : "PDF Download"}
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>

      <Table style={{ width: "100%" }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
            {header.map((header, index) => (
              <TableCell key={index} onClick={() => handleSort(index)}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "left",
                    cursor: "pointer",
                  }}
                >
                  {header.label}
                  {formState.sortColumn === index &&
                    (formState.isAsc ? (
                      <ArrowUpward fontSize="small" />
                    ) : (
                      <ArrowDownward fontSize="small" />
                    ))}
                </div>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              {[...Array(header.length)].map((header, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ) :data.length> 0 ? (
            data?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {header.map((header, colIndex) => (
                  <TableCell
                    key={colIndex}
                    align={header.key === "invoiceAmount" ? "right" : "left"}
                  >
                    {
                      header.key === "invoiceNo" ?
                        <div onClick={() => handleInvoiceClick(row?.role, row?.status, row?.invoice_ID, row?.vendorCode)} style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}>{row[header.key]}</div> :
                        header.key === "invoiceDate" ||
                          header.key === "submissionDate"
                          ? FormatDate(row[header.key]) // Format the date
                          : header.key === "invoiceAmount"
                            ? FormatAmount(row[header.key]) // Format the amount
                            : row[header.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ):(
            <TableRow>
            <TableCell colSpan={4}><EmptyData/></TableCell>
          </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 500, 1000]}
        component="div"
        count={count}
        rowsPerPage={formState.RowsOfPage}
        page={parseInt(formState.PageNo) - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default NoCompilanceBased;
